// SPDX-License-Identifier: Elastic-2.0
/**
 * AiSection — Settings → AI.
 *
 * Local LLM has been removed (F-613). Cloud AI is always active for
 * Plus/Pro tiers; no user-configurable model selection is available.
 */
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { Card } from "@/components/Card/Card";

import styles from "./AiSection.module.css";

export function AiSection(): ReactElement {
  const { t } = useTranslation();

  return (
    <Card as="section" variant="elevated" padding="md" data-testid="settings-ai">
      <h2 className={styles.title}>{t("settings.ai.section_title")}</h2>
      <p className={styles.helper}>{t("settings.ai.cloud_only_notice")}</p>
    </Card>
  );
}

export default AiSection;
